import { SpecialPriceState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: SpecialPriceState = {
  specialPrice: null,
  specialPrices: [],
  count: 0,
  loading: true,
  applicable: {},
};

export const specialPriceSlice = createSlice({
  name: "specialPrice",
  initialState,
  reducers: {
    clear: (state) => {
      state.specialPrices = [];
      state.specialPrice = null;
      state.count = 0;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSpecialPrice: (state, action) => {
      state.specialPrice = action.payload;
    },
    setSpecialPrices: (state, action) => {
      const { specialPrices, count } = action.payload;
      state.specialPrices = specialPrices;
      state.count = count ?? specialPrices?.length ?? 0;
    },
    updateSpecialPrice: (state, action) => {
      const { id, specialPrice } = action.payload;
      const index = state.specialPrices.findIndex(
        (item: any) => item?._id === id
      );
      if (index >= 0) state.specialPrices[index] = specialPrice;
    },
    deleteSpecialPrices: (state, action) => {
      const { ids } = action.payload;
      const removed = new Set((ids || []).map((id: any) => String(id)));
      state.specialPrices = state.specialPrices.filter(
        (item: any) => !removed.has(String(item?._id))
      );
      state.count = state.specialPrices.length;
    },
    deleteSpecialPrice: (state, action) => {
      const { id } = action.payload;
      state.specialPrices = state.specialPrices.filter(
        (item: any) => item?._id !== id
      );
      state.count = state.specialPrices.length;
    },
    /**
     * Percentages in force for one zone at one pickup instant, keyed
     * `${zone_id}|${iso}` so booking rows sharing a datetime reuse one lookup.
     *
     * Only the raw percentages are cached — never a price. Writing an increased
     * price into a cached rate card is how the increase would compound on every
     * re-render.
     */
    setApplicable: (state, action) => {
      const { key, percentByClass } = action.payload;
      state.applicable[key] = percentByClass;
    },
    clearApplicable: (state) => {
      state.applicable = {};
    },
  },
});

const specialPriceReducer = specialPriceSlice.reducer;

export const specialPriceActions = specialPriceSlice.actions;
export default specialPriceReducer;
